<template>
  <header v-if="AuthStore.status" class="fixed left-0 right-0 top-0 p-1 header">
    <div class="top-left-buttons flex flex-direction-row align-center list-style-type-none">
      <li v-if="AuthStore.role == 'INSTRUCTOR'" class="mt-auto mb-auto">
        <router-link
          :to="{ name: 'instructor-feed' }"
          class="inline-block pl-2 pr-2"
        >
          <img
            title="Home"
            class="logo"
            src="@/assets/images/logo_cropped.png"
          />
        </router-link>
      </li>
      <li
        v-else-if="AuthStore.role == 'INDUSTRYPRACTITIONER'"
        class="lg:ml-3 mt-auto mb-auto"
      >
        <router-link
          :to="{ name: 'industry-practitioner-feed' }"
          class="inline-block pl-2 pr-2"
        >
          <img
            title="Home"
            class="logo"
            src="@/assets/images/logo_cropped.png"
          />
        </router-link>
      </li>
      <li v-else-if="AuthStore.role == 'ADMIN'" class="lg:ml-3 my-auto">
        <router-link
          :to="{ name: 'admin-feed' }"
          class="admin-logo inline-block pl-2 pr-2 pt-2"
        >
          <img
            title="Home"
            src="@/assets/images/logo_cropped.png"
          />
        </router-link>
      </li>
      <li
        v-if="
          AuthStore.role == 'INDUSTRYPRACTITIONER' ||
          AuthStore.role == 'INSTRUCTOR'
        "
        class="pl-1"
      >
        <router-link
          :to="{ name: 'view-uploads' }"
          class="my-uploads nav-item nav-link rounded-2"
        >
          <img
            src="@/assets/images/file_upload.png"
            class="sidebar-image-large mr-1"
            alt="Upload Resources"
          />
          <span class="button-text header-text">My Uploads</span>
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'contact-us' }"
          class="social-media-button p-1 rounded-2 lg:p-2"
          title="Contact Us"
        >
          <img
            src="@/assets/images/site/contact-us.png"
            class="sidebar-image-large"
          />
          <span class="button-text">Contact Us</span>
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'about' }"
          class="social-media-button p-1 rounded-2 lg:p-2"
          title="About Us"
          ><img
            src="@/assets/images/site/about.png"
            class="sidebar-image-large"
          />
          <span class="button-text">About Us </span>
        </router-link>
      </li>
      <!-- <li v-else></li> -->
      <li class="ml-1">
        <!--        <router-link-->
        <!--          :to="{ name: 'dashboard' }"-->
        <!--          class="nav-item nav-link rounded-2"-->
        <!--        >-->
        <!--          <font-awesome-icon-->
        <!--            icon="fa-solid fa-chart-line"-->
        <!--            class="header-link"-->
        <!--            title="Dashboard"-->
        <!--          />-->
        <!--          <span class="header-text">Dashboard</span>-->
        <!--        </router-link>-->
      </li>
    </div>
    <header-search-bar v-if="AuthStore.status"></header-search-bar>
    <div>
      <div class="list-style-type-none ml-auto">
        <li
          class="nav-item cursor-pointer rounded-2"
          @click.prevent="logOut"
        >
          <font-awesome-icon
            icon="fa-solid fa-right-from-bracket"
            class="log-out-btn header-link"
            title="Log Out"
          />
          <span class="header-text">Log Out</span>
        </li>
      </div>
    </div>
  </header>
  <header v-else class="fixed left-0 right-0 top-0 p-1 header">
    <div class="flex flex-direction-row align-center list-style-type-none">
      <li class="header-buttons lg:ml-3 mt-2 mb-2">
        <router-link
          :to="{ name: 'instructor-feed' }"
          class="nav-item inline-block pl-2 pr-2"
        >
          <img
            title="Home"
            class="logo"
            src="@/assets/images/logo_cropped.png"
          />
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'contact-us' }"
          class="social-media-button p-1 rounded-2 lg:p-2"
          title="Contact Us"
        >
          <img
            src="@/assets/images/site/contact-us.png"
            class="sidebar-image-large"
          />
          <span class="button-text"> Contact Us</span>
        </router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'about' }"
          class="social-media-button p-1 rounded-2 lg:p-2"
          title="About Us"
          ><img
            src="@/assets/images/site/about.png"
            class="sidebar-image-large"
          />
          <span class="button-text"> About Us </span>
        </router-link>
      </li>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useConfigStore } from "@/stores/ConfigStore";
import { useAuthStore } from "@/stores/AuthStore";
import { useRouter } from "vue-router";
import HeaderSearchBar from "@/components/user/HeaderSearchBar.vue";

const ConfigStore = useConfigStore();
const AuthStore = useAuthStore();
const router = useRouter();

const logOut = () => {
  AuthStore.logout();
  router.push("/");
};

ConfigStore.getConfig();
</script>

<style scoped>
.grid-header {
  width: 100%;
  display: grid;
  grid-template-columns: 100px 1fr 100px;
}
.top-left-buttons {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-end;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.header-link {
  margin: 0.2em 0.4em 0.2em 0.1em;
  cursor: pointer;
}

.header-text {
  vertical-align: top;
  margin-left: 0.3em;
}

header {
  background: var(--secondary-background-color);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
  height: 4em;
  overflow: hidden;
  box-shadow: 0px 0px 10px 4px rgb(0 0 0 / 30%);
  z-index: 9999;
}

.nav-item {
  padding: 0.5rem;
  background: #fff;
  white-space: nowrap;
}

.nav-item:hover {
  background: var(--primary-background-color);
}

.logo {
  max-width: 2.5em;
  min-width: 3em;
  max-height: 2.5em;
  min-height: 3em;
}

.social-media-button {
  font-size: 2vh;
  color: #000;
  display: inline-block;
  flex-direction: column;
  text-decoration: none;
  cursor: pointer;
  padding: 0.5rem;
  width: 20vh;
}

.social-media-button:hover {
  background: var(--primary-background-color);
  transition: background 0.2s, color 0.2s;
}

.my-uploads {
  font-size: large;
  width: 10em;
  padding: 0.5rem;
}
  
.log-out-btn {
  width: auto;
  margin-right: 0.3em;    /* Adds a little space between icon and text */
  vertical-align: middle;
  display: inline-block;
}

.button-text {
  margin-left: 0.1em;
}

.admin-logo {
  width: 80px;
  height: 80px;
}

@media (max-width: 600px) {

  .social-media-button .button-text{ 
    display: none;
  }
  .header-text {
    display: none;
  }

  .social-media-button {
    display: none;
  }

  .my-uploads {
    display: none;
  }

  .log-out-btn {
    width: 3em;
  }
}
</style>
